import { render } from "./MainMenu.vue?vue&type=template&id=e6e29e8e&scoped=true&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=e6e29e8e&scoped=true&lang=css"

import exportComponent from "/Users/alexvoina/Development/myhouse-booking-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e29e8e"]])

export default __exports__